<template>
  <div>
    <el-table :data="dataList" border stripe ref="dataTable" v-loading="dataListLoading" style="width: 100%;"
      :header-cell-style="this.$globalGrayTableHeaderStyle">
      <el-table-column type="index" label="序号" width="50" fixed :index="getRowsIndex" align="center">
      </el-table-column>
      <el-table-column prop="bidCode" show-overflow-tooltip label="标段编号" align="center" fixed width="210">
      </el-table-column>
      <el-table-column prop="bidName" show-overflow-tooltip label="标段名称" header-align="left" align="left" fixed
        width="400">
      </el-table-column>
      <el-table-column prop="bidOpenTime" :show-overflow-tooltip="true" label="开标时间" align="center"  width="200">
      </el-table-column>
      <el-table-column prop="superviseDeptName" :show-overflow-tooltip="true" label="监督部门" align="left" width="200">
      </el-table-column>
      <el-table-column prop="bidopenSuperviseManName" show-overflow-tooltip label="开标监督人" align="center" width="150">
      </el-table-column>
      <el-table-column prop="bidopenSuperviseTime" show-overflow-tooltip label="开标监督记录提交时间" align="center" width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.bidOpeningHistory == 2 ? scope.row.bidopenSuperviseTime : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="evalSuperviseManName" label="评标监督人" align="center" width="150">
      </el-table-column>
      <el-table-column prop="evalSuperviseTime" label="评标监督记录提交时间" align="center" width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.evalHistory == 2 ? scope.row.evalSuperviseTime : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="bidOpeningHistory" label="开标监督记录" width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <span class="triangle" v-if="scope.row.bidOpeningHistory == 1"></span>
          <el-button type="text" size="small" v-if="scope.row.bidOpeningHistory != 0"
            @click="showOpenDetail(scope.row)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="evalHistory" width="120" fixed="right" align="center" label="评标监督记录">
        <template slot-scope="scope">
          <span class="triangle" v-if="scope.row.evalHistory == 1"></span>
          <el-button type="text" size="small" v-if="scope.row.evalHistory != 0" @click="showDetail(scope.row)">查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper" />
  </div>
</template>
<script>
import { queryOpenEvalRecordList } from '@/server/bidOpenEvalWitness';
export default {
  props: ['search'],
  components: {
  },
  data() {
    return {
      dataListLoading: false,
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
    };
  },
  created() {
    this.getDataList();
  },
  activated() {

  },
  mounted() {
  },
  methods: {
    getRowsIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 获取数据列表
    getDataList(params) {
      this.dataListLoading = false;
      queryOpenEvalRecordList({
        page: this.pageIndex,
        rows: this.pageSize,
        filter: {
          "bidName": params ? params.bidName : (this.search.bidName || ''), //项目名称
          "bidCode": params ? params.bidCode : (this.search.bidCode || ''),//所属机构
          startTime: params && params.dateRange[0] ? params.dateRange[0] : (this.search.dateRange && this.search.dateRange[0] || ''),
          endTime: params && params.dateRange[1] ? params.dateRange[1] : (this.search.dateRange && this.search.dateRange[1] || ''),
          deptCode: params ? params.deptCode : (this.search.deptCode || ''),
          superviseDeptCode: params ? params.deptCode : (this.search.deptCode || ''),
          superviseDeptCodeList:params? params.superviseDeptCodeList:[],// 数据所属部门
        },
        searchKey: '',
      }).then((res) => {
        this.dataList = res.data.rows;
        this.$refs.dataTable.doLayout();
        this.totalPage = res.data.total;
        // this.pageIndex = res.data.pageIndex
      })
    },
    // 开标监督记录
    showOpenDetail(row) {
      let route_name = "";
      if (row.bidOpeningHistory == 1) {
        route_name = 'openBidWitness_detail';
      } else {
        route_name = 'openBidWitness_view';
      }
      removeTabHandle(route_name)
      this.$router.push({
        name: route_name,
        query: {
          bidCode: row.bidCode,
          businessType: 'GC'
        }
      })
    },
    // 评标监督记录
    showDetail(row) {
      let route_name = "";
      if (row.evalHistory == 1) {
        route_name = 'estimateBidWitness_detail';
      } else {
        route_name = 'estimateBidWitness_view';
      }
      removeTabHandle(route_name)
      this.$router.push({
        name: route_name,
        query: {
          bidCode: row.bidCode,
          businessType: 'GC'
        }
      })
    },
  },
};
</script>
<style scoped lang="scss">
.triangle {
  position: absolute;
  /*left: 0px;*/
  /*top: 0px;*/
  /*width: 0;*/
  /*height: 0;*/
  /*border-top: 14px solid #FF9900;*/
  /*border-right: 14px solid transparent;*/
  left: 72px;
  top: 12px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #FF9900;
}
</style>